import React from "react";
import { useHistory } from "react-router-dom";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { GetMonthNameByNumber } from "../../Helper/GetMonthNameByNumber";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

export const NivelInventarioItem = ({ data, sucursales }) => {
  const history = useHistory();
  const año = new Date().getFullYear();
  const mesActual = new Date().getMonth() + 1;
  const GetClass = (value, minimo = 20, medium = 81) => {
    if (value <= minimo) return "circle-red";
    else if (value <= medium) return "circle-yellow";
    else return "circle-success";
  };
  const handleClickNivelInventario = () => {
    history.push("/Finanzas/NivelInventario", sucursales);
  };

  // console.log(data?.inventarioAntiguedad)
  const nivel = data?.nivelInventario

  const formatmiles = (number) => {
    return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
  };

  const calcularporcentaje = (param, ventasNetas) => {
    if (!ventasNetas) return 0;
    return ((param / ventasNetas) * 100).toFixed(2);
  };
  // console.log('nivel inventario' + data)
  return (
    <div className="dashboard-financiero-container-box-2" onClick={handleClickNivelInventario}>
      <div className="dashboard-financiero-container-box-titulo">
        Nivel de Inventario
      </div>
      <div className="dashboard-financiero-container-box-info df_box_nivel_inventario">
        <table className="nivel-inventario-table">
          <thead>
            <tr>
              <th>Línea</th>
              <th className="ta-right">{año}</th>
              <th className="ta-right">{año - 1}</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {nivel.map((item, index) => (
              <tr key={index}>
                <td>{capitalizePalabras(item.concepto)}</td>
                <td className="ta-right">{formatmiles(item.totalactual)}</td>
                <td className="ta-right">{formatmiles(item.totalanterior)}</td>
                <td className="ta-center">{item.diferencia}</td>
                {/* <td className="ta-center">{formatmiles(item.suma_Costo)}</td> */}
              </tr>
            ))}
            {/* <tr>
              <td>{GetMonthNameByNumber(mesActual)} {año}</td>
              <td>{formatmiles(nivel[0].invactual) ?? 0}</td>
              <td>{nivel[0].dias ?? 0}</td>
            </tr>
            <tr>
              <td>{GetMonthNameByNumber(mesActual)} {año - 1}</td>
              <td>{formatmiles(nivel[0].invanterior) ?? 0}</td>
              <td>{nivel[0].diasant ?? 0}</td>
            </tr> */}
            {/* <tr>
              <td>Diferencia</td>
              <td colSpan={2}>{FormatMoney(nivel[0].diferencia, 2)} %</td>
            </tr> */}
          </tbody>
        </table>
      </div>
    </div>
  );
};
